var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.988,
    height: 41.669,
    opacity: 0.75,
    viewBox: "0 0 32.988 41.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(51 54.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(-56 -54.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M36.252,5.365c0-2.6.252-3.785-.955-4.775a2.6,2.6,0,0,0-2.17-.538C1.137,6.893,10.625,4.766,8.82,5.261A4.341,4.341,0,0,0,5,9.549V37.328a4.341,4.341,0,0,0,4.341,4.341H35.384a2.6,2.6,0,0,0,2.6-2.6V7.813a2.6,2.6,0,0,0-1.736-2.448ZM33.474,1.736a.868.868,0,0,1,1.042.868v2.6H17.327ZM6.736,37.328V9.549a2.6,2.6,0,0,1,2.6-2.6h.868V39.933H9.341A2.6,2.6,0,0,1,6.736,37.328Zm29.516,1.736a.868.868,0,0,1-.868.868H11.945V6.945H35.384a.868.868,0,0,1,.868.868Z",
    transform: "translate(0 0)",
    fill: "#1c474a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M33.859,17.784C30.3,8.443,17,11.2,17,20.684a8.681,8.681,0,0,0,17.362,0,8.3,8.3,0,0,0-.5-2.9Zm-7.969,9.844a3.333,3.333,0,0,1-.417,0,11.381,11.381,0,0,1-1.84-3.472h4.1a11.381,11.381,0,0,1-1.84,3.472ZM23.224,22.42a10.139,10.139,0,0,1,0-3.472h4.913a10.139,10.139,0,0,1,0,3.472Zm-4.262,0a6.823,6.823,0,0,1,0-3.472h2.509a11.641,11.641,0,0,0,0,3.472Zm6.528-8.681h.382a11.285,11.285,0,0,1,1.858,3.472h-4.1a11.285,11.285,0,0,1,1.858-3.472Zm4.4,5.209H32.4a7.014,7.014,0,0,1,0,3.472c0,.087.148,0-2.518,0a11.641,11.641,0,0,0,.009-3.472Zm1.788-1.736H29.527a12.787,12.787,0,0,0-1.241-2.96,7.023,7.023,0,0,1,3.394,2.96Zm-8.6-2.96a12.787,12.787,0,0,0-1.241,2.96H19.682A6.945,6.945,0,0,1,23.077,14.251Zm-3.394,9.905h2.153a12.787,12.787,0,0,0,1.241,2.96,7.023,7.023,0,0,1-3.394-2.96Zm8.6,2.96a12.787,12.787,0,0,0,1.241-2.96H31.68A6.945,6.945,0,0,1,28.285,27.116Z",
    transform: "translate(-1.583 -1.585)",
    fill: "#1c474a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M33.494,40H17.868a.868.868,0,0,0,0,1.736H33.494a.868.868,0,1,0,0-1.736Z",
    transform: "translate(-1.583 -5.276)",
    fill: "#1c474a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0fa51075ba05a96fb6fa43effb210ca0.svg";
export { ForwardRef as ReactComponent };